<template>
  <div class="flex-align unselect" :style="`margin-left:4px;height:${iconSize}px`" @click="clickIcon" @mouseover="hover" @mouseleave="leave">
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0003 18.8334C6.95783 18.8334 3.66699 15.5425 3.66699 11.5C3.66699 7.45752 6.95783 4.16669 11.0003 4.16669C15.0428 4.16669 18.3337 7.45752 18.3337 11.5C18.3337 15.5425 15.0428 18.8334 11.0003 18.8334Z" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.83325 11.5C1.83325 6.43998 5.93992 2.33331 10.9999 2.33331C16.0599 2.33331 20.1666 6.43998 20.1666 11.5C20.1666 16.56 16.0599 20.6666 10.9999 20.6666C5.93992 20.6666 1.83325 16.56 1.83325 11.5ZM11.9166 15.1666V17H10.0833V15.1666H11.9166ZM10.9999 18.8333C6.95742 18.8333 3.66659 15.5425 3.66659 11.5C3.66659 7.45748 6.95742 4.16665 10.9999 4.16665C15.0424 4.16665 18.3333 7.45748 18.3333 11.5C18.3333 15.5425 15.0424 18.8333 10.9999 18.8333ZM7.33325 9.66665C7.33325 7.64081 8.97409 5.99998 10.9999 5.99998C13.0258 5.99998 14.6666 7.64081 14.6666 9.66665C14.6666 10.8427 13.9424 11.4755 13.2373 12.0917C12.5684 12.6763 11.9166 13.2459 11.9166 14.25H10.0833C10.0833 12.5805 10.9469 11.9185 11.7062 11.3365C12.3018 10.88 12.8333 10.4726 12.8333 9.66665C12.8333 8.65831 12.0083 7.83331 10.9999 7.83331C9.99159 7.83331 9.16659 8.65831 9.16659 9.66665H7.33325Z"
            :fill="color"/>
    </svg>

    <!--<i class="material-icons icon-info unselect"
       :style="{fontSize: iconSize+'px'}"
       style="font-size:18px;margin-left:4px">info_outline</i>-->
  </div>
</template>
<script>
  export default {
    name: "LinkIcon",
    props: {
      iconSize: {
        type: Number,
        default: 22
      },
      link: {
        type: String,
        default: ''
      }
    },
    created() {
    },
    data() {
      return {
        color: '#aeaeae'
      }
    },
    methods: {
      clickIcon() {
        window.open(this.link, '_blank');
      },
      hover() {
        this.color = '#ff5722';
      },
      leave() {
        this.color = '#aeaeae';
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .icon-info
    vertical-align middle
    color #BDBDBD
  .icon-info:hover
    color #ff5722
</style>
